<div
  class="field"
  [ngClass]="{
    'field--light': theme === 'light',
    'field--dark': theme === 'dark',
    'field--inline': display === 'inline',
    'field--compact': isCompact
  }"
  data-test="formField">
  <label [attr.aria-label]="label" #labelEl>
    <div
      *ngIf="label"
      class="field__label text-10"
      [class.text-uppercase]="uppercase"
      data-test="formFieldLabel">
      {{ label }}
    </div>

    <div class="field__input">
      <ng-content></ng-content>

      <div class="field__help text-dim text-11">
        <ng-content select="[form-field-help]"></ng-content>
      </div>
    </div>
  </label>
</div>
